<template>
  <v-dialog v-model="show" persistent max-width="700px">
    <v-card v-if="isShow" :class="classContents">
      <v-card-title>
        <h3>{{ modeTitle }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon x-small @click="close()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form">
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.whitelist.filterType') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="copyFormData.alertWhitelistType" :items="_whitelistTypes" item-text="text" item-value="value" class="w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.whitelist.taskType') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="copyFormData.taskType" :items="_teskTypes" item-text="text" item-value="value" class="w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.whitelist.sapUserId') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.account" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.whitelist.report') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.report" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.whitelist.tcode') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.tcode" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.whitelist.rfcFunctionName') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.rfcFunctionName" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.active') }}</span>
              </div>
              <div class="float-left column-contents chk-min-con">
                <v-checkbox v-model="copyFormData.active" :disabled="copyFormData.active === undefined" class="kpi-chk-mgt" dense></v-checkbox>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('alert.description') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="copyFormData.description" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="save()" :loading="loading" :disabled="!btnDisabled" small color="primary">{{ this.$t('common.save') }}</v-btn>
        <v-btn @click="close()" small color="primary">{{ this.$t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'WhiteListForm',
  props: {
    formData: Object,
    formMode: String,
  },
  data() {
    return {
      show: false,
      isShow: false,
      loading: false,
      copyFormData: {},
    };
  },
  computed: {
    ...mapState('preference/alert', ['addWhitelist', 'updateWhitelist']),
    ...mapGetters('preference/alert', ['_teskTypes', '_whitelistTypes']),
    modeTitle() {
      return this.formMode !== 'new' ? this.$t('alert.white.form.title.edit') : this.$t('alert.white.form.title.add');
    },
    btnDisabled() {
      // eslint-disable-next-line prettier/prettier
      return (this.copyFormData.alertWhitelistType === 'TASK_TYPE' && !!this.copyFormData.taskType)
        || (this.copyFormData.alertWhitelistType === 'ACCOUNT' && !!this.copyFormData.account)
        || (this.copyFormData.alertWhitelistType === 'REPORT' && !!this.copyFormData.report)
        || (this.copyFormData.alertWhitelistType === 'TCODE' && !!this.copyFormData.tcode)
        || (this.copyFormData.alertWhitelistType === 'RFM' && !!this.copyFormData.rfcFunctionName);
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  watch: {
    show(val) {
      if (val) this.copyPropdata();
    },
    copyFormData() {
      this.isShow = true;
    },
    updateWhitelist(val) {
      if (val === 'success') this.close();
    },
    addWhitelist(val) {
      if (val === 'success') this.close();
    },
  },
  methods: {
    async copyPropdata() {
      this.copyFormData = await { ...this.formData };
    },
    save() {
      let actionName = this.formMode === 'new' ? 'preference/alert/addWhitelist' : 'preference/alert/updateWhitelist';
      this.$store.dispatch(actionName, this.copyFormData);
    },
    close() {
      this.show = false;
      this.isShow = false;
    },
  },
};
</script>
